import { useState, useEffect, useMemo } from 'react';
import { capitalizeFirstLetter } from '../functions';
import PropTypes from 'prop-types';
import TagButton from './TagButton';
import SearchBar from './SearchBar';

const TagList = ({ itemFormData, completeTagData, tagTypeData, onTagClick }) => {
  const [selectedTagType, setSelectedTagType] = useState({ id: 0, type: 'any' });
  const [tagFilter, setTagFilter] = useState('');

  const combinedTags = useMemo(() => {
    const tagDataMap = new Map(completeTagData.map(tag => [tag.id, tag]));
    return [
      ...completeTagData,
      ...itemFormData.tags.filter(tag => !tagDataMap.has(tag.id))
    ];
  }, [completeTagData, itemFormData]);

  const [filteredTagData, setFilteredTagData] = useState(combinedTags);
  const [availableTagTypes, setAvailableTagTypes] = useState(tagTypeData);

  useEffect(() => {
    let filteredData = combinedTags;

    if (tagFilter) {
      filteredData = filteredData.filter(tag =>
        tag.name.toLowerCase().includes(tagFilter.toLowerCase())
      );
    }

    if (selectedTagType.id !== 0) {
      filteredData = filteredData.filter(tag =>
        tag.tagTypes.some(type => type.id === selectedTagType.id)
      );
    }

    setFilteredTagData(filteredData);
  }, [tagFilter, selectedTagType, combinedTags]);

  useEffect(() => {
    const updatedAvailableTagTypes = tagTypeData.filter(type =>
      combinedTags.some(tag =>
        tag.tagTypes.some(tagType => tagType.id === type.id) &&
        tag.name.toLowerCase().includes(tagFilter.toLowerCase())
      )
    );
    setAvailableTagTypes(updatedAvailableTagTypes);
  }, [tagFilter, tagTypeData, combinedTags]);

  const handleTypeChange = (typeObj) => {
    setSelectedTagType(typeObj.id === selectedTagType.id ? { id: 0, type: 'any' } : typeObj);
  };

  const resetTagTypeFilter = () => {
    setSelectedTagType({ id: 0, type: 'any' });
  };

  return (
    <div>
      <SearchBar
        searchValue={tagFilter}
        setSearchValue={setTagFilter}
        placeHolder={'Filter Tags by Key Word'}
        options={filteredTagData}
      />
      <div>
        Tag Type Filter:
        <select
          id="typeSelect"
          value={selectedTagType.id}
          onChange={(e) => {
            const selectedTagTypeId = Number(e.target.value);
            const selectedType = availableTagTypes.find(type => type.id === selectedTagTypeId) || { id: 0, type: 'any' };
            handleTypeChange(selectedType);
          }}
        >
          <option key={0} value={0}>Any</option>
          {availableTagTypes.map(type => (
            <option key={type.id} value={type.id}>
              {capitalizeFirstLetter(type.type)}
            </option>
          ))}
        </select>
        <button onClick={resetTagTypeFilter} disabled={selectedTagType.id === 0}>Any</button>
      </div>
      {filteredTagData.length > 0 ? (
        filteredTagData.map((tag, i) => (
          <TagButton
            key={i}
            tagName={tag.name}
            isSelected={itemFormData.tags.some(selectedTag => selectedTag.id === tag.id)}
            onClick={() => onTagClick(tag)}
          />
        ))
      ) : (
        <div style={{ color: 'yellow' }}>No Tags Found</div>
      )}
    </div>
  );
};

TagList.propTypes = {
  itemFormData: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired
  }).isRequired,
  completeTagData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  tagTypeData: PropTypes.array,
  onTagClick: PropTypes.func.isRequired,
};

export default TagList;
